"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ProductListWithTranslations = require("./ProductListWithTranslations");
Object.keys(_ProductListWithTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ProductListWithTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ProductListWithTranslations[key];
    }
  });
});
